import api from '../../services/api';
import { NUDGES_BASE, NUDGES_UNREAD, NUDGES_SENT } from '../../config/Config';

// Get unread nudges for the authenticated student
export const getUnreadNudges = async () => {
  const response = await api.get(NUDGES_UNREAD);
  return response.data;
};

// Mark a nudge as read
export const markNudgeRead = async (id) => {
  const data = { read: true };
  await api.patch(`${NUDGES_BASE}${id}/mark_read/`, data);
};

// Send a nudge message
export const sendNudge = async (recipientId, text) => {
  const data = { recipient: recipientId, text };
  const response = await api.post(NUDGES_BASE, data);
  return response.data;
};

// Get sent nudges for the authenticated user (teachers/parents)
export const getSentNudges = async () => {
  const response = await api.get(NUDGES_SENT);
  return response.data;
};
